module.exports = __webpack_public_path__ + "img/login.3f94fb57.png";